<template>
  <div class="animated fadeIn">
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import AccountMixin from '@/store/module/account/mixin'
import decodeJwt from '@/shared/utils/decodeJwt'

export default {
  name: 'StartPageFila',
  mixins: [ActionsForm, AccountMixin],
  data () {
    return {
      isTablet: screen.width <= 768,
      username: '',
      userRole: ''
    }
  },
  created () {
    const decoded = decodeJwt()
    if (decoded) {
      this.username = decoded.username || decoded.name || 'Usuário'
      this.userRole = decoded.roles || ''

      if (this.userRole === 'ROLE_TOTEM') {
        this.$router.push('/totem')
      } else if (this.userRole === 'ROLE_TV') {
        this.$router.push('/tv')
      } else {
        console.warn('Role desconhecida:', this.userRole)
      }
    }
  },
  mounted () {
    if (!this.username || this.username === 'Usuário') {
      this.username = this.getCookie('username') || 'Usuário não identificado'
    }
  },
  methods: {
    getCookie (name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
    },
    logout () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.pt-3 h4 {
  font-size: 1.2rem !important;
  word-break: keep-all;
}
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
.card-header {
  background-color: #2dce89;
  color: white;
  font-weight: bold;
}
.btn-primary {
  background-color: #2dcecc;
  border-color: #2dcecc;
}
.btn-primary:hover {
  background-color: #28a745;
  border-color: #28a745;
}
.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:hover {
  background-color: #c82333;
  border-color: #bd2130;
}
h4 {
  font-size: 1.15rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
.card-body {
  padding: 0.25rem;
}
.top-BG {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 45vh;
  background: linear-gradient(90deg, #2dce89 0%, #2dcecc 100%);
}
.welcome-text {
  color: white;
  font-size: 2rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/StartPage/StartPageFila.vue